import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postFetch } from '@legacy/utils/fetcher';
import { INewManualPeriodResponse } from '../types';
import { EXCHANGE_RATE_GET_PERIODS_KEY } from '../get/getPeriodsAPI';
import { GET_EXCHANGE_RATE_MATRIX_ACTIONS_KEY } from '../get/getMatrixActionsAPI';

const POST_EXCHANGE_RATE_NEW_MANUAL_PERIOD =
  '/api/v1/exchange-rate/manual-period';
export const POST_EXCHANGE_RATE_NEW_MANUAL_MSW_STATUS_KEY =
  'postNewManualPeriod';

const postExchangeRateNewManualPeriod = (
  endDate: string,
): Promise<INewManualPeriodResponse> =>
  postFetch({
    path: POST_EXCHANGE_RATE_NEW_MANUAL_PERIOD,
    key: POST_EXCHANGE_RATE_NEW_MANUAL_MSW_STATUS_KEY,
    body: JSON.stringify({
      endDate,
    }),
  });

export const usePostExchangeRateNewManualPeriod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postExchangeRateNewManualPeriod,

    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [EXCHANGE_RATE_GET_PERIODS_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EXCHANGE_RATE_MATRIX_ACTIONS_KEY],
        }),
      ]),
  });
};
